import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "default-layout" }
const _hoisted_2 = { id: "main-container" }
const _hoisted_3 = {
  id: "main-container-scroll",
  class: "flex flex-column h-screen overflow-auto"
}
const _hoisted_4 = { id: "main-content" }
const _hoisted_5 = { class: "flex max-width" }

import { onMounted } from 'vue';
import SidebarMenu from '@/components/SidebarMenu';
import Nav from '@/components/Nav';
import MessageCenter from '@/components/MessageCenter';
import { useChurnZero, useTrackEvent } from '@/composables';
import { useAuthStore } from '@/store';
import { useRouting } from '@/composables';
import { AuthUserInterface } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'Default',
  setup(__props) {

const $routing = useRouting();
const useAuth = useAuthStore();

$routing.routeChangeWatcher(() => {
  useChurnZero(useAuth.user as AuthUserInterface, useAuth.organizationExternalId as string);
  useTrackEvent($routing?.route?.name as string);
});

onMounted(() => {
  useChurnZero(useAuth.user as AuthUserInterface, useAuth.organizationExternalId as string);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Nav), { class: "sticky top-0 left-0 mb-2" }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(SidebarMenu)),
              _renderSlot(_ctx.$slots, "default")
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_unref(MessageCenter))
  ], 64))
}
}

})